module.exports = __webpack_public_path__ + "img/dashboard-bg1.3d26e482.jpg";